export default "__VITE_ASSET__C9Rcsj0F__"